export default function AWLogo({ size = 40, invert = false }) {
  return (
    <img
      src="/aw-logo.png"
      alt="AutoWorld AW monogram"
      data-testid="aw-logo"
      className={`select-none object-contain ${invert ? "invert" : ""}`}
      style={{ height: size, width: "auto" }}
    />
  );
}
